import _toConsumableArray from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { C as Connector, _ as _defineProperty, a as _classPrivateFieldInitSpec, n as normalizeChainId, U as UserRejectedRequestError, d as _classPrivateFieldGet, c as _classPrivateFieldSet, e as allChains, S as SwitchChainError } from '../../../dist/base-2a0d02bb.esm.js';
import { Web3Provider } from '@ethersproject/providers';
import { CoinbaseWalletSDK } from '@coinbase/wallet-sdk';
import { getAddress, hexValue } from 'ethers/lib/utils';
import 'eventemitter3';

var _client = /*#__PURE__*/new WeakMap();

var _provider = /*#__PURE__*/new WeakMap();

var CoinbaseWalletConnector = /*#__PURE__*/function (_Connector) {
  _inherits(CoinbaseWalletConnector, _Connector);

  var _super = _createSuper(CoinbaseWalletConnector);

  function CoinbaseWalletConnector(config) {
    var _this;

    _classCallCheck(this, CoinbaseWalletConnector);

    var _window$ethereum;

    _this = _super.call(this, config);

    _defineProperty(_assertThisInitialized(_this), "id", 'coinbasewallet');

    _defineProperty(_assertThisInitialized(_this), "name", 'Coinbase Wallet');

    _defineProperty(_assertThisInitialized(_this), "ready", typeof window !== 'undefined' && !((_window$ethereum = window.ethereum) !== null && _window$ethereum !== void 0 && _window$ethereum.isCoinbaseWallet));

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _client, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _provider, {
      writable: true,
      value: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit('disconnect');else _this.emit('change', {
        account: getAddress(accounts[0])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = normalizeChainId(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit('change', {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDisconnect", function () {
      _this.emit('disconnect');
    });

    return _this;
  }

  _createClass(CoinbaseWalletConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var provider, accounts, account, id, unsupported;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                provider = this.getProvider();
                provider.on('accountsChanged', this.onAccountsChanged);
                provider.on('chainChanged', this.onChainChanged);
                provider.on('disconnect', this.onDisconnect);
                _context.next = 7;
                return provider.enable();

              case 7:
                accounts = _context.sent;
                account = getAddress(accounts[0]);
                _context.next = 11;
                return this.getChainId();

              case 11:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id);
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: new Web3Provider(provider)
                });

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);

                if (!/user closed modal/i.test(_context.t0.message)) {
                  _context.next = 20;
                  break;
                }

                throw new UserRejectedRequestError();

              case 20:
                throw _context.t0;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var provider, n, key;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_classPrivateFieldGet(this, _provider)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                provider = this.getProvider();
                provider.removeListener('accountsChanged', this.onAccountsChanged);
                provider.removeListener('chainChanged', this.onChainChanged);
                provider.removeListener('disconnect', this.onDisconnect);
                provider.disconnect();
                provider.close();

                if (!(typeof localStorage !== 'undefined')) {
                  _context2.next = 19;
                  break;
                }

                n = localStorage.length;

              case 10:
                if (!n--) {
                  _context2.next = 19;
                  break;
                }

                key = localStorage.key(n);

                if (key) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("continue", 10);

              case 14:
                if (/-walletlink/.test(key)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("continue", 10);

              case 16:
                localStorage.removeItem(key);
                _context2.next = 10;
                break;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var provider, accounts;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                provider = this.getProvider();
                _context3.next = 3;
                return provider.request({
                  method: 'eth_accounts'
                });

              case 3:
                accounts = _context3.sent;
                return _context3.abrupt("return", getAddress(accounts[0]));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var provider, chainId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                provider = this.getProvider();
                chainId = normalizeChainId(provider.chainId);
                return _context4.abrupt("return", chainId);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function getProvider() {
      if (!_classPrivateFieldGet(this, _provider)) {
        _classPrivateFieldSet(this, _client, new CoinbaseWalletSDK(this.options));

        _classPrivateFieldSet(this, _provider, _classPrivateFieldGet(this, _client).makeWeb3Provider(this.options.jsonRpcUrl));
      }

      return _classPrivateFieldGet(this, _provider);
    }
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var provider, account;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                provider = this.getProvider();
                _context5.next = 3;
                return this.getAccount();

              case 3:
                account = _context5.sent;
                return _context5.abrupt("return", new Web3Provider(provider).getSigner(account));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var account;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.getAccount();

              case 3:
                account = _context6.sent;
                return _context6.abrupt("return", !!account);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", false);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(chainId) {
        var provider, id, chains;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                provider = this.getProvider();
                id = hexValue(chainId);
                _context7.prev = 2;
                _context7.next = 5;
                return provider.request({
                  method: 'wallet_switchEthereumChain',
                  params: [{
                    chainId: id
                  }]
                });

              case 5:
                chains = [].concat(_toConsumableArray(this.chains), _toConsumableArray(allChains));
                return _context7.abrupt("return", chains.find(function (x) {
                  return x.id === chainId;
                }));

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);

                if (!/user rejected signature request/i.test(_context7.t0.message)) {
                  _context7.next = 15;
                  break;
                }

                throw new UserRejectedRequestError();

              case 15:
                throw new SwitchChainError();

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 9]]);
      }));

      function switchChain(_x) {
        return _switchChain.apply(this, arguments);
      }

      return switchChain;
    }()
  }]);

  return CoinbaseWalletConnector;
}(Connector);

export { CoinbaseWalletConnector };